<template>
	<div style="height:35%">
		<h3 class="ts-text-xs ts-uppercase ts-text-blue-700">{{ $t('productProfile.addOnItem') }}</h3>
		<div class="ts-pl-8 ts-space-y-2">
			<a-select
				v-model="model.recipes"
				mode="multiple"
				:maxTagCount="4"
				:options="recipeList"
				showSearch
                :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
				:disabled="model.product_type_id == 3"
				class="ts-w-full"
			></a-select>
		</div>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
export default {
  name: 'addOnItem',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
	},
	computed: {
		recipeList(){
			return this.$store.state.product.profile.productRecipe.map(el => ({
				value: el.pro_sale_code_id,
				label: el.pro_group_name + '-' + el.product_name_en + '-' + el.sale_code
			}))
		}
	},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>